/**
 * Created by Michal on 10.04.2017.
 */

let moment = require('moment');
import _ from 'lodash';

(function (DataTableSettingsEmailAliases, $, undefined) {

    //Public Method
    DataTableSettingsEmailAliases.renderName = function (row, type, val, meta) {
        return row.name;
    };

    DataTableSettingsEmailAliases.renderUsers = function (row, type, val, meta) {
        return _.map(row.users, 'full_name').join(', ');
    };

}(window.DataTableSettingsEmailAliases = window.DataTableSettingsEmailAliases || {}, jQuery));

(function (DataTableSettingsProjectCategories, $, undefined) {

    //Public Method
    DataTableSettingsProjectCategories.renderName = function (row, type, val, meta) {
        return '<span class="badge" style="color:#fff; background-color: ' + row.color + '">' + row.name + '</span>';
    };

    DataTableSettingsProjectCategories.renderPaidProject = function (row, type, val, meta) {
        return row.paid_project_label;

    };

}(window.DataTableSettingsProjectCategories = window.DataTableSettingsProjectCategories || {}, jQuery));

(function (DataTableSettingsBudgetCampaignTypes, $, undefined) {

    //Public Method
    DataTableSettingsBudgetCampaignTypes.renderName = function (row, type, val, meta) {
        return row.name;
    };

}(window.DataTableSettingsBudgetCampaignTypes = window.DataTableSettingsBudgetCampaignTypes || {}, jQuery));

(function (DataTableSettingsProjectNoteTypes, $, undefined) {

    //Public Method
    DataTableSettingsProjectNoteTypes.renderName = function (row, type, val, meta) {
        return '<span class="badge" style="color:#fff; background-color: ' + row.color + '">' + row.name + '</span>';
    };

}(window.DataTableSettingsProjectNoteTypes = window.DataTableSettingsProjectNoteTypes || {}, jQuery));

(function (DataTableSettingsArchiveProjectReasonTypes, $, undefined) {

    //Public Method
    DataTableSettingsArchiveProjectReasonTypes.renderName = function (row, type, val, meta) {
        return '<span class="badge" style="color:#fff; background-color: ' + row.color + '">' + row.name + '</span>';
    };

}(window.DataTableSettingsArchiveProjectReasonTypes = window.DataTableSettingsArchiveProjectReasonTypes || {}, jQuery));


(function (DataTableVisiGroups, $, undefined) {

    //Public Method
    DataTableVisiGroups.renderName = function (row, type, val, meta) {
        return '<span class="badge" style="color:#fff; background-color: ' + row.color + '">' + row.name + '</span>';
    };

}(window.DataTableVisiGroups = window.DataTableVisiGroups || {}, jQuery));

(function (DataTableClients, $, undefined) {

    //Public Method
    DataTableClients.renderCompanyName = function (row, type, val, meta) {
        return '<a href="' + laroute.route('clients.show', {client: row.id}) + '">' + row.company_name + '</a>';
    };

    DataTableClients.renderContactPeople = function (row, type, val, meta) {
        return _.map(row.contact_people, function (contactPerson) {
            return '<a href="mailto:' + contactPerson.email + '">' + contactPerson.name + '</a>';
        }).join(', ');
    };
    DataTableClients.renderActiveClient = function (row, type, val, meta) {
        return row.active_client_label;
    }

}(window.DataTableClients = window.DataTableClients || {}, jQuery));

(function (DataTableUsers, $, undefined) {

    //Public Method
    DataTableUsers.renderFullName = function (row, type, val, meta) {
        return '<a href="' + laroute.route('users.show', {user: row.id}) + '">' + row.full_name + '</a>';
    };

    DataTableUsers.renderVisiGroupName = function (row, type, val, meta) {
        if (!row.visi_group) {
            return 'Unknown';
        }
        return row.visi_group.name;
    };

    DataTableUsers.renderMaxHours = function (row, type, val, meta) {
        return row.max_hours;
    };

    DataTableUsers.renderFreeHours = function (date, value, capacity) {

        let capacityForThisMonth = 0;
        if (_.hasIn(capacity, date.get('year') + '.' + (date.get('month') + 1))) {
            capacityForThisMonth = capacity[date.get('year')][date.get('month') + 1];
        }
        return Render.renderNumber(capacityForThisMonth - value);
    };

    DataTableUsers.renderFreeHours1 = function (row, type, val, meta) {
        let date = moment().add(-1, 'month');
        return DataTableUsers.renderFreeHours(date, row.allocate_hours1, row.capacity);
    };

    DataTableUsers.renderFreeHours2 = function (row, type, val, meta) {
        let date = moment().add(0, 'month');
        return DataTableUsers.renderFreeHours(date, row.allocate_hours2, row.capacity);
    };

    DataTableUsers.renderFreeHours3 = function (row, type, val, meta) {
        let date = moment().add(1, 'month');
        return DataTableUsers.renderFreeHours(date, row.allocate_hours3, row.capacity);
    };

    DataTableUsers.renderFreeHours4 = function (row, type, val, meta) {
        let date = moment().add(2, 'month');
        return DataTableUsers.renderFreeHours(date, row.allocate_hours4, row.capacity);
    };

}(window.DataTableUsers = window.DataTableUsers || {}, jQuery));

(function (DataTableProjects, $, undefined) {

    DataTableProjects.renderName = function (row, type, val, meta) {

        let result = '';
        if (row.project_category) {

            result += '<span class="flag-relative"><span class="flag">';

            result += '<span style="background-color:' + row.project_category.color + '" class="label" title="' + row.project_category.name + '"></span>';

            result += '</span><span class="flag flag-big">';

            result += '<span style="background-color:' + row.project_category.color + '" class="label" title="' + row.project_category.name + '">' + row.project_category.name + '</span>';

            result += '</span></span>';
        }

        result += '<a href="' + laroute.route('projects.show', {project: row.id}) + '">' + row.name + '</a>';

        return result;

    };

    DataTableProjects.renderClientCompanyName = function (row, type, val, meta) {
        if (!row.client) {
            return 'Undefined';
        }
        return '<a href="' + laroute.route('clients.show', {client: row.client.id}) + '">' + row.client.company_name + '</a>';
    };

    DataTableProjects.renderOwnerFullName = function (row, type, val, meta) {
        if (!row.owner) {
            return 'Undefined';
        }
        return Render.renderUserName(row.owner);
    };

    DataTableProjects.renderSalesManagerFullName = function (row, type, val, meta) {
        if (!row.sales_manager) {
            return 'Undefined';
        }
        return Render.renderUserName(row.sales_manager);
    };

    DataTableProjects.renderEstimatedHours = function (row, type, val, meta) {
        return Render.formatNumber(row.estimated_hours);
    };

    DataTableProjects.renderRemainingHours = function (row, type, val, meta) {
        return Render.formatNumber(row.remaining_hours);
    };

    DataTableProjects.renderBudgetMonthly = function (row, type, val, meta) {
        if (!row.budget) {
            return '-';
        }
        return Render.formatNumber(row.budget, 2, '', ' €');
    };

    DataTableProjects.renderStartDate = function (row, type, val, meta) {
        return Render.renderDateSpecial(row.start_date, false);
    };

    DataTableProjects.renderDeadline = function (row, type, val, meta) {
        return Render.renderDateSpecial(row.deadline, true);
    };
    DataTableProjects.renderArchivedDeadline = function (row, type, val, meta) {
        return Render.renderDateSpecial(row.deadline, false);
    };

}(window.DataTableProjects = window.DataTableProjects || {}, jQuery));


(function (DataTableTasks, $, undefined) {

    DataTableTasks.renderName = function (row, type, val, meta) {
        return '<a href="' + laroute.route('tasks.show', {task: row.id}) + '">' + row.name + '</a>';
    };
    DataTableTasks.renderOwnerFullName = function (row, type, val, meta) {
        if (!row.owner) {
            return 'Undefined';
        }
        return Render.renderUserName(row.owner);
    };

    DataTableTasks.renderClientCompanyName = function (row, type, val, meta) {
        if (!row.project || !row.project.client) {
            return 'Undefined';
        }

        return '<a href="' + laroute.route('clients.show', {client: row.project.client.id}) + '">' + row.project.client.company_name + '</a>';
    };

    DataTableTasks.renderOwnerVisiGroupName = function (row, type, val, meta) {
        if (!row.owner || !row.owner.visi_group) {
            return 'Undefined';
        }
        return '<span class="badge" style="color:#fff; background-color: ' + row.owner.visi_group.color + '">' + row.owner.visi_group.name + '</span>';
        ;
    };

    DataTableTasks.renderProjectName = function (row, type, val, meta) {
        if (!row.project) {
            return 'Undefined';
        }
        return '<a href="' + laroute.route('projects.show', {project: row.project_id}) + '">' + row.project.name + '</a>';
    };

    DataTableTasks.renderProjectOwnerFullName = function (row, type, val, meta) {
        if (!row.project || !row.project.owner) {
            return 'Undefined';
        }
        return Render.renderUserName(row.project.owner);
    };

    DataTableTasks.renderSalesManagerFullName = function (row, type, val, meta) {
        if (!row.project || !row.project.sales_manager) {
            return 'Undefined';
        }
        return Render.renderUserName(row.project.sales_manager);
    };

    DataTableTasks.renderEstimatedHours = function (row, type, val, meta) {
        return Render.formatNumber(row.estimated_hours);
    };

    DataTableTasks.renderRemainingHours = function (row, type, val, meta) {
        if (row.remaining_hours < 0) {
            return '<span class="text-danger">' + Render.formatNumber(row.remaining_hours) + '</span>';
        }
        return Render.formatNumber(row.remaining_hours);
    };

    DataTableTasks.renderSpentHours = function (row, type, val, meta) {
        if (row.spent_hours < 0) {
            return '<span class="text-danger">' + Render.formatNumber(row.spent_hours) + '</span>';
        }

        return Render.formatNumber(row.spent_hours);
    };


    DataTableTasks.renderStartDate = function (row, type, val, meta) {
        return Render.renderDateSpecial(row.start_date, false);
    };

    DataTableTasks.renderDeadline = function (row, type, val, meta) {
        return Render.renderDateSpecial(row.deadline, true);
    };

    DataTableTasks.renderStatus = function (row, type, val, meta) {
        return row.done_label;
    };

    DataTableTasks.renderOneTime = function (row, type, val, meta) {
        if (row.one_time) {
            return '<span class="sr-only">One Time</span><span class="ion ion-ios-skipforward"></span>';
        }
        return '<span class="sr-only">Regular</span><span class="ion ion-loop"></span>';
    };

}(window.DataTableTasks = window.DataTableTasks || {}, jQuery));


(function (DataTableSettingsTickListDefaultGroups, $, undefined) {

    //Public Method
    DataTableSettingsTickListDefaultGroups.renderName = function (row, type, val, meta) {
        return "<a href='" + laroute.route('settings_owner.tick_list_default_groups.show', {tick_list_default_group: row.id}) + "'>" + row.name + '</a>';
    };

}(window.DataTableSettingsTickListDefaultGroups = window.DataTableSettingsTickListDefaultGroups || {}, jQuery));

(function (DataTableSettingsTickListDefaultItems, $, undefined) {

    //Public Method
    DataTableSettingsTickListDefaultItems.renderPhase = function (row, type, val, meta) {
        return row.phase;
    };
    DataTableSettingsTickListDefaultItems.renderWho = function (row, type, val, meta) {
        return row.who;
    };
    DataTableSettingsTickListDefaultItems.renderTask = function (row, type, val, meta) {
        return row.task;
    };
    DataTableSettingsTickListDefaultItems.renderNote = function (row, type, val, meta) {
        return row.note;
    };
}(window.DataTableSettingsTickListDefaultItems = window.DataTableSettingsTickListDefaultItems || {}, jQuery));




// WEBPACK FOOTER //
// ./resources/assets/js/app/dataTableRenderFunctions.js